<fgb-mobile-page-header [pageTitle]="'mobile.page.predictor.header.title'" backButtonLink="/games" />
<div class="games-banner">
  <div class="container">
    <div class="games-banner-frame">
      <a class="games-banner-buttons d-lg-flex d-none" [routerLink]="['/games']">
        <i class="material-icons text-white">chevron_left</i>
        <span>{{ 'games.banner.back.title' | translate }}</span>
      </a>
      <div class="banner-img-container">
        <img
          [src]="'banners/predictor-banner.jpg' | contentAssetImage"
          alt="Games Banners"
          width="962"
          height="210"
          class="games-banner-banners"
        />
      </div>
    </div>
  </div>
</div>
<div class="games-nav-container">
  <div class="container">
    <fgb-game-nav>
      <a
        class="nav-item"
        [routerLink]="['/games/predictor']"
        [routerLinkActive]="'active'"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <label class="mb-0">{{ 'games.nav.play' | translate }}</label>
      </a>
      <a
        class="nav-item"
        [routerLink]="['/games/predictor/leaderboard']"
        [routerLinkActive]="'active'"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <label class="mb-0">{{ 'games.nav.leaderboard' | translate }}</label>
      </a>
    </fgb-game-nav>
  </div>
</div>

<router-outlet></router-outlet>
